import React from 'react';
import {
  Card,
  CardContent,
  Box,
  Typography,
  Button,
} from '@mui/material';
import {
  Image as ImageIcon,
  Visibility,
  Edit,
} from '@mui/icons-material';
import { styled } from '@mui/material/styles';
import { Product } from '../../types/api/products';
import { StatusChip } from '../common';

const ProductCardContainer = styled(Card)(({ theme }) => ({
  height: '100%',
  display: 'flex',
  flexDirection: 'column',
  transition: 'all 0.3s ease-in-out',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: theme.shadows[6],
  },
}));

interface ProductCardProps {
  product: Product;
  onView: (product: Product) => void;
  onEdit: (product: Product) => void;
}

const ProductCard: React.FC<ProductCardProps> = ({ product, onView, onEdit }) => {
  return (
    <ProductCardContainer>
      <Box
        sx={{
          height: 200,
          bgcolor: 'grey.100',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundImage: product.primary_image_url 
            ? `url(https://server.bitsindia.in${product.primary_image_url})`
            : 'none',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {!product.primary_image_url && (
          <ImageIcon sx={{ fontSize: 48, color: 'text.secondary' }} />
        )}
      </Box>
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" gutterBottom noWrap>
          {product.name}
        </Typography>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          {product.brand_name} • {product.category_name}
        </Typography>
        {product.description && (
          <Typography variant="body2" sx={{ mb: 2 }}>
            {product.description.slice(0, 100)}...
          </Typography>
        )}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <StatusChip status={product.verification_status} variant="verification" />
          <Typography variant="caption" color="text.secondary">
            {new Date(product.created_at).toLocaleDateString()}
          </Typography>
        </Box>
      </CardContent>
      <Box sx={{ p: 2, pt: 0 }}>
        <Button 
          size="small" 
          startIcon={<Visibility />}
          onClick={() => onView(product)}
          sx={{ mr: 1 }}
        >
          View
        </Button>
        <Button 
          size="small" 
          startIcon={<Edit />}
          onClick={() => onEdit(product)}
        >
          Edit
        </Button>
      </Box>
    </ProductCardContainer>
  );
};

export default ProductCard;